import { render, staticRenderFns } from "./WelcomeView.vue?vue&type=template&id=a11d69c8&scoped=true&"
import script from "./WelcomeView.vue?vue&type=script&lang=ts&"
export * from "./WelcomeView.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeView.vue?vue&type=style&index=0&id=a11d69c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11d69c8",
  null
  
)

export default component.exports